<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import { SortOrder } from './Table.svelte'

	type Props = {
		column: string | null
		sortColumn: string | null
		sortOrder: SortOrder | null
		onSort: (column: string, order?: SortOrder) => void
	}
	let { column = null, sortColumn = null, sortOrder = null, onSort }: Props = $props()

	const handleClick = (event: MouseEvent) => {
		event.stopPropagation()

		if (sortColumn === column) {
			const nextOrder = sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
			onSort(column!, nextOrder)
		} else {
			onSort(column!, SortOrder.DESC)
		}
	}
</script>

<button onclick={handleClick}>
	{#if sortColumn === column && sortOrder === SortOrder.DESC}
		<Icon name="arrowUp" size="sm" />
	{:else}
		<Icon name="arrowDown" size="sm" />
	{/if}
</button>
